import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconSegundamano from '../build/icon-segundamano'

export const IconSegundamano: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconSegundamano} />
}

export default IconSegundamano
